import { render, staticRenderFns } from "./NotaInterna.vue?vue&type=template&id=5945eedc&scoped=true&"
import script from "./NotaInterna.vue?vue&type=script&lang=js&"
export * from "./NotaInterna.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5945eedc",
  null
  
)

export default component.exports